<div class="surface-card p-4 shadow-2 border-round w-full lg:w-6">
  <!-- Header Section -->
  <div class="text-center mb-5">
        <img src="assets/brand/{{
            layoutService.colorScheme() === 'light'
              ? 'logo-light'
              : 'logo-dark'
          }}.png" alt="Sequal App Logo" height="50" class="mb-3" />
    <div class="text-900 text-3xl font-medium mb-3">
      Create Your Account
    </div>
    <span class="text-600 font-medium line-height-3">Already have an account?</span>
    <a (click)="navigateToLogin()" class="font-medium no-underline ml-2 text-blue-500 cursor-pointer">Sign In</a>
  </div>

  <!-- Registration Form -->
  <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
    <!-- Email Field -->
    <div class="mb-3">
      <label for="email" class="block text-900 font-medium mb-2">Email</label>
      <input id="email" type="email" placeholder="Email address" pInputText formControlName="email"
        class="w-full mb-3" />
      @if (emailErrorText(); as emailErr) {
        <small class="p-error">
          {{ emailErr }}
        </small>
      }
    </div>

    <!-- Password Field -->
    <div class="mb-4">
      <label for="password" class="block text-900 font-medium mb-2">Password</label>
      <p-password id="password" placeholder="Password" [feedback]="false" [toggleMask]="true"
        formControlName="password" styleClass="w-full" [style]="{'width':'100%'}"
      [inputStyle]="{'width':'100%'}"></p-password>
      @if (passwordErrorText(); as passwordErr) {
        <small class="p-error">
          {{ passwordErr }}
        </small>
      }
    </div>

    <!-- Confirm Password Field -->
    <div class="mb-5">
      <label for="confirmPassword" class="block text-900 font-medium mb-2">Confirm Password</label>
      <p-password id="confirmPassword" placeholder="Confirm Password" [feedback]="false" [toggleMask]="true"
        formControlName="confirmPassword" styleClass="w-full" [style]="{'width':'100%'}"
      [inputStyle]="{'width':'100%'}"></p-password>
      @if (confirmPasswordErrorText(); as confirmErr) {
        <small class="p-error">
          {{ confirmErr }}
        </small>
      }
    </div>

    <!-- Captcha -->
    @if (isCaptchaRequired()) {
      <div class="mb-3 sm:mb-4">
        <app-captcha />
      </div>
    }

    <!-- Error Message — above the button, next to the fields it is about. -->
    @if (registrationFailed()) {
      <p class="p-error mt-3" role="alert" aria-live="assertive">
        Registration failed. Please try again.
      </p>
    }

    <!-- Register Button -->
    <button pButton pRipple label="Sign Up" icon="pi pi-user-plus" class="w-full"
    [disabled]="registerForm.invalid || isSubmitting()" [loading]="isSubmitting()"></button>
  </form>
</div>